import axios from "axios";
import store from "@/store";
import VeeValidate from "vee-validate";

var host = window.location.protocol + "//" + window.location.host;

async function readCompanies() {
  var response = await axios({
    method: "get",
    url: "/locales/",
    baseURL: host
  });

  if (process.env.NODE_ENV === "production") {
    return response.data.map(el => el.name).filter(el => el != "images");
  } else {
    return response.data.filter(el => el != "images");
  }
}

async function readFilesForCompany(companyName) {
  var response = await axios({
    method: "get",
    url: "/locales/" + companyName + "/",
    baseURL: host
  });
  var locales = {};
  var tempData;
  if (process.env.NODE_ENV === "production") {
    tempData = response.data.map(el => el.name);
  } else {
    tempData = response.data;
  }
  var promises = tempData
    .filter(el => el.includes(".json"))
    .map(element => {
      return new Promise(async resolve => {
        var elResp = await axios({
          method: "get",
          url: "/locales/" + companyName + "/" + element,
          baseURL: host
        });
        var name = element.replaceAll(".json", "");
        locales[name] = elResp.data;
        resolve();
      });
    });

  await Promise.all(promises);
  return locales;
}

export default {
  install(Vue) {
    try {
      readCompanies().then(companies => {
        companies.forEach(async company => {
          var locale = await readFilesForCompany(company);
          store.dispatch("pushLocales", {
            company: company.toLowerCase().trim(),
            locale
          });
        });
      });
    } catch (error) {}
    const locales = {
      lang: Vue.observable({ actual: "pl" }),
      t(key, defaultValue, lang) {
        if (!lang) {
          lang = this.lang.actual;
        }
        return store.getters.getTranslation(lang, key.trim(), defaultValue);
      },
      changeLocale(lang) {
        this.lang.actual = lang;
        document.documentElement.lang = lang;
      }
    };

    Vue.$locales = locales;
    Vue.prototype.$locales = locales;

    Vue.use(VeeValidate);

    const validateDictionary = {
      pl: {
        messages: {
          email: () => Vue.$locales.t("validation.email", "To nie jest email"),
          required: () =>
            Vue.$locales.t("validation.required", "To pole jest wymagane"),
          numeric: () =>
            Vue.$locales.t("validation.number", "To nie jest numer"),
          phoneNumber: () =>
            Vue.$locales.t(
              "validation.phone_number",
              "To nie jest numer telefonu"
            ),
          regex: () =>
            Vue.$locales.t(
              "validation.regex",
              "Pole nie zgadza sie z wymaganiami"
            ),
          min: (_field, arg) =>
            Vue.$locales.t("validation.minimum", "Minumum liczba znakow") +
            `:${arg}`,
          max: (_field, arg) =>
            Vue.$locales.t("validation.maximum", "Maksymalna liczba znakow") +
            `:${arg}`
        }
      }
    };
    VeeValidate.Validator.extend("phoneNumber", {
      getMessage: _field =>
        Vue.$locales.t("validation.phone_number", "To nie jest numer telefonu"),
      validate: value => /^\+?[0-9]{3}-?[0-9]{6,12}$/.test(value)
    });

    VeeValidate.Validator.extend("noascii", {
      getMessage: _field =>
        Vue.$locales.t("validation.noascii", "Niepoprawne znaki"),
      validate: value => /^[\u0000-\u007f]*$/.test(value)
    });

    VeeValidate.Validator.localize("pl");
    VeeValidate.Validator.localize("pl", validateDictionary.pl);
  }
};
